import UserDictionaries from './UserDictionaries';

export default UserDictionaries;
